import type { MyTaskItem } from '@/types/domain'

/** Where a «Мои задачи» row opens (S-2b.1, S-2b.2).
 *
 *  A quote opens the quote, a case the case — and a leg item opens the LEG
 *  (`/cases/:caseId/legs/:legId`), because the truck it is missing is added
 *  there. The item's `id` is the case's even on a leg item; `legId` is served
 *  on `case-no-vehicle` (the road leg with no truck) and, since S-12, on
 *  `case-truck-double-count` (the first leg whose truck rates are counted
 *  twice, answered on that leg's unit cards).
 *
 *  A rate-change request opens the Finance page's approvals tab, not the case:
 *  it is decided there, and the requester's reason — restricted free text the
 *  task item deliberately leaves out (AD-6) — is shown only there. The item
 *  carries no case id for the same reason. */
export function taskHref(item: MyTaskItem): string {
  if (item.kind === 'approval') return '/finance?tab=approvals'
  if (item.kind === 'quote') return `/quotes/${item.id}`
  if (item.legId) return `/cases/${item.id}/legs/${item.legId}`
  return `/cases/${item.id}`
}

/** The payment-confirmation queue, all time — the list the sidebar's Finance
 *  badge and the `payments-to-confirm` count both count (QW-10). */
export const PAYMENTS_QUEUE_HREF = '/finance?tab=payments&pending=1'

/** Where the «К оплате» line on «Мои задачи» sends Finance (S-2b.2, B1): the
 *  balances, over every period. A "go and act" link, NOT a drill-through — the
 *  figure is the dashboard's to-pay counter, and the link does not promise a
 *  list that sums to it (the rule `TILE_HREFS` on the dashboard holds a
 *  drill-through to). */
export const TO_PAY_HREF = '/finance?tab=balances&range=all'
